module.exports = require('./src/normalizeWheel.js');



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/normalize-wheel@1.0.1/~/normalize-wheel/index.js
// module id = 219
// module chunks = 0